class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((e) => {
      this.onSubmitHandler(e);
    }, 500);

    this.querySelector('form').addEventListener('input', (e) => {
      // Invalidate anything in flight the instant the user clicks, so a slow/stale
      // response can never overwrite the checkbox they just changed.
      FacetFiltersForm.cancelInFlight();
      FacetFiltersForm.syncMirrors(e.target);
      this.debouncedOnSubmit(e);
    });

    var e = this.querySelector('#FacetsWrapperDesktop');
    if (e) e.addEventListener('keyup', onKeyUpEscape);

    e = this.querySelector('.facets__button-show');
    if (e) {
      e.onclick = () => {
        this.querySelector('.facets__wrapper').classList.add('active');
        this.closest('.collection-wrapper').querySelector('.facets-container').classList.add('active');
        this.closest('.collection-wrapper').querySelector('.products-grid__overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
        this.querySelectorAll(
          '.facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button '
        ).forEach((e) => {
          e.removeAttribute('tabindex');
        });
      };

      this.querySelector('.facets__close').onclick = () => {
        this.querySelector('.facets__wrapper').classList.remove('active');
        this.closest('.collection-wrapper').querySelector('.facets-container').classList.remove('active');
        this.closest('.collection-wrapper').querySelector('.products-grid__overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        this.querySelectorAll(
          '.facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button '
        ).forEach((e) => {
          e.setAttribute('tabindex', '-1');
        });
      };

      window.addEventListener('keyup', (e) => {
        if ('ESCAPE' === e.code.toUpperCase()) {
          this.querySelector('.facets__wrapper').classList.remove('active');
          this.closest('.collection-wrapper').querySelector('.facets-container').classList.remove('active');
          this.closest('.collection-wrapper').querySelector('.products-grid__overlay').classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          this.querySelectorAll(
            '.facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button '
          ).forEach((e) => {
            e.setAttribute('tabindex', '-1');
          });
        }
      });
    }

    document.addEventListener('click', (e) => {
      var t = document.querySelectorAll('.facets__wrapper--horizontal .facets__disclosure'),
        r = e.target.closest('.facets__disclosure[open]'),
        a = document.querySelector('.facets__wrapper--horizontal_united'),
        c = e.target.closest('.facets__wrapper--horizontal_united'),
        l = e.target.closest('.loading-overlay');

      if (
        a &&
        a != c &&
        !e.target.closest('.facets__reset ') &&
        document.querySelector('.facets__button-show') != e.target.closest('.facets__button-show') &&
        document.querySelector('.loading-overlay') != l
      ) {
        a.classList.remove('active');
        if (e.target.closest('.products-grid__overlay')) {
          e.target.closest('.products-grid__overlay').classList.remove('active');
        }
        document.body.classList.remove('overflow-hidden');
      }

      if (!r && t) {
        t.forEach((e) => {
          e.removeAttribute('open');
        });
      }
    });
  }

  static calcMinHeight = () => {
    var e = document.querySelector('.facets__top'),
      t = document.querySelector('.facets__sort-wrapper'),
      r = document.querySelector('.collection-wrapper');

    if (e && t && r) {
      r.style.gridTemplateRows =
        t.getBoundingClientRect().height > e.getBoundingClientRect().height
          ? t.getBoundingClientRect().height + 'px auto 1fr'
          : e.getBoundingClientRect().height + 'px auto 1fr';
    }
  };

  static setListeners() {
    window.addEventListener('popstate', (e) => {
      e = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (e !== FacetFiltersForm.searchParamsPrev) {
        FacetFiltersForm.renderPage(e, null, false);
      }
    });
  }

  // Every duplicate copy of the clicked checkbox (other form, drawer, pills, hidden list...)
  // is forced to the same state, so a stale copy can never re-add a value the user unticked.
  static syncMirrors(t) {
    if (!t || t.type !== 'checkbox' || !t.name) return;
    document.querySelectorAll('input[type="checkbox"]').forEach((o) => {
      if (o !== t && o.name === t.name && o.value === t.value) o.checked = t.checked;
    });
  }

  static dedupeParams(usp) {
    const seen = new Set();
    const out = new URLSearchParams();
    usp.forEach((v, k) => {
      const key = k + '\u0000' + v;
      if (!seen.has(key)) {
        seen.add(key);
        out.append(k, v);
      }
    });
    return out;
  }

  static cancelInFlight() {
    FacetFiltersForm.requestId = (FacetFiltersForm.requestId || 0) + 1;
    if (FacetFiltersForm.abortController) {
      FacetFiltersForm.abortController.abort();
      FacetFiltersForm.abortController = null;
    }
    // also stop any infinite-scroll / load-more page fetch that belongs to the old filter set
    if (typeof window.cancelLoadMore === 'function') window.cancelLoadMore();
  }

  static clearLoading() {
    const grid = document.querySelector('#ProductGridContainer .collection');
    if (grid) grid.classList.remove('loading');
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('loading');
    });
    const btn = document.querySelector('.button--results');
    if (btn) btn.classList.remove('loading');
  }

  static toggleActiveFacets(t = true) {
    document.querySelectorAll('.js-facet-remove').forEach((e) => {
      e.classList.toggle('disabled', t);
    });
  }

  static renderPage(r, a, e = true) {
    FacetFiltersForm.searchParamsPrev = r;
    FacetFiltersForm.cancelInFlight();

    var t = FacetFiltersForm.getSections(),
      c = document.getElementById('ProductCount'),
      l = document.getElementById('ProductCountDesktop'),
      s = document.querySelector('.button--results');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (c) c.classList.add('loading');
    if (l) {
      l.classList.add('loading');
    } else {
      document.querySelector('.loading-overlay').style.top = '0';
    }
    if (s) s.classList.add('loading');

    t.forEach((e) => {
      let t = `${window.location.pathname}?section_id=${e.section}&` + r;
      e = (e) => e.url === t;

      if (FacetFiltersForm.filterData.some(e)) {
        FacetFiltersForm.renderSectionFromCache(e, a);
      } else {
        FacetFiltersForm.renderSectionFromFetch(t, a);
      }
    });

    if (e) FacetFiltersForm.updateURLHash(r);
  }

  static renderSectionFromFetch(t, r) {
    const controller = new AbortController();
    FacetFiltersForm.abortController = controller;
    const myId = FacetFiltersForm.requestId;

    fetch(t, { signal: controller.signal })
      .then((e) => {
        if (!e.ok) throw new Error('Filter request failed: ' + e.status);
        return e.text();
      })
      .then((e) => {
        // a newer click happened while this was loading -> throw this response away
        if (myId !== FacetFiltersForm.requestId) return;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: e, url: t }];
        FacetFiltersForm.renderFilters(e, r);
        FacetFiltersForm.renderProductGridContainer(e);
        FacetFiltersForm.renderProductCount(e);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.error(err);
        if (myId === FacetFiltersForm.requestId) FacetFiltersForm.clearLoading();
      });
  }

  static renderSectionFromCache(e, t) {
    e = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(e, t);
    FacetFiltersForm.renderProductGridContainer(e);
    FacetFiltersForm.renderProductCount(e);
  }

  static renderProductGridContainer(e) {
    const parsedDoc = new DOMParser().parseFromString(e, 'text/html');
    document.getElementById('ProductGridContainer').innerHTML =
      parsedDoc.getElementById('ProductGridContainer').innerHTML;

    // keep the collection title count (in the banner section) in sync with the active filters
    const countEl = parsedDoc.querySelector('[data-filtered-count]');
    if (countEl) {
      document.querySelectorAll('.collection-product-count').forEach((el) => {
        el.textContent = '(' + countEl.dataset.filteredCount + ')';
      });
    }

    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) {
      loadMore();
    }
    colorSwatches();
  }

  static renderProductCount(e) {
    var e = new DOMParser().parseFromString(e, 'text/html').getElementById('ProductCount').innerHTML,
      t = document.getElementById('ProductCount'),
      r = document.getElementById('ProductCountDesktop'),
      a = document.querySelector('.button--results');

    t.innerHTML = e;
    t.classList.remove('loading');
    if (a) a.classList.remove('loading');
    if (r) {
      r.innerHTML = e;
      r.classList.remove('loading');
    }

    document
      .querySelectorAll('.facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ')
      .forEach((e) => {
        e.removeAttribute('tabindex');
      });
  }

  static renderFilters(e, r) {
    var e = new DOMParser().parseFromString(e, 'text/html'),
      incoming = e.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersFormMobile .js-filter'
      );

    const FORMS = '#FacetFiltersForm, #FacetFiltersPillsForm, #FacetFiltersFormMobile';
    const clickedEl = r && r.target ? r.target.closest('.js-filter') : null;
    let clickedIncoming = null;

    // A filter group's identity = its data-index + the names of its inputs.
    // (Index alone / position alone is NOT unique on this theme -> groups got each other's HTML.)
    const groupKey = (el) => {
      const names = [...new Set([...el.querySelectorAll('input[name]')].map((i) => i.name))].sort().join(',');
      const fallback = names
        ? ''
        : ((el.querySelector('summary') || el).textContent || '').trim().replace(/\s+/g, ' ').slice(0, 30);
      return (el.dataset.index || '') + '|' + names + fallback;
    };

    const counters = {};
    incoming.forEach((inc) => {
      const formId = inc.closest(FORMS) ? inc.closest(FORMS).id : null;
      const key = (formId || '') + '#' + groupKey(inc);
      const n = (counters[key] = (counters[key] || 0) + 1) - 1; // k-th copy of THIS exact group
      const scope = formId ? '#' + formId + ' ' : '';
      const targets = Array.from(document.querySelectorAll(scope + '.js-filter')).filter(
        (t) => groupKey(t) === groupKey(inc)
      );
      const target = targets[n];
      if (!target) return; // no exact match -> leave it alone rather than overwrite the wrong group

      if (target === clickedEl) {
        clickedIncoming = inc;
        return;
      }
      target.innerHTML = inc.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(e);

    if (clickedIncoming) {
      FacetFiltersForm.renderCounts(clickedIncoming, clickedEl);
    }
  }

  static renderActiveFacets(r) {
    ['.active-facets-desktop'].forEach((e) => {
      var t = r.querySelector(e);
      if (t) {
        document.querySelector(e).innerHTML = t.innerHTML;
        FacetFiltersForm.calcMinHeight();
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(e, t) {
    var r = t.querySelector('.facets__selected'),
      a = e.querySelector('.facets__selected'),
      c = t.querySelector('.facets__summary'),
      l = e.querySelector('.facets__summary');

    if (a && r) {
      t.querySelector('.facets__selected').outerHTML = e.querySelector('.facets__selected').outerHTML;
    }
    if (c && l) {
      t.querySelector('.facets__summary').outerHTML = e.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(e) {
    history.pushState({ searchParams: e }, '', '' + window.location.pathname + (e && '?'.concat(e)));
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(e) {
    e = new FormData(e);
    return new URLSearchParams(e).toString();
  }

  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
  }

  onSubmitHandler(e) {
    e.preventDefault();

    const srcForm = e.target.closest('form');

    if ('mobile-facets__checkbox' == e.srcElement.className) {
      this.onSubmitForm(FacetFiltersForm.dedupeParams(new URLSearchParams(this.createSearchParams(srcForm))).toString(), e);
      return;
    }

    document.querySelectorAll('.no-js-list').forEach((el) => el.remove());

    const FILTER_FORMS = ['FacetFiltersForm', 'FacetFiltersFormMobile'];
    const SORT_FORMS = ['FacetSortForm', 'FacetSortDrawerForm'];
    const allForms = Array.from(document.querySelectorAll('facet-filters-form form'));
    const isVisible = (f) => f.offsetParent !== null;

    // Desktop + mobile forms are MIRRORS of each other; merging both re-adds values
    // the user just unticked. Filters come from ONE form: the one the user touched,
    // otherwise the visible one.
    let filterForm = FILTER_FORMS.includes(srcForm && srcForm.id) ? srcForm : null;
    if (!filterForm) {
      const candidates = allForms.filter((f) => FILTER_FORMS.includes(f.id));
      filterForm = candidates.find(isVisible) || candidates[0] || null;
    }

    let sortForm = SORT_FORMS.includes(srcForm && srcForm.id) ? srcForm : null;
    if (!sortForm) {
      const candidates = allForms.filter((f) => SORT_FORMS.includes(f.id));
      sortForm = candidates.find(isVisible) || candidates[0] || null;
    }

    const params = new URLSearchParams();
    if (filterForm) {
      new FormData(filterForm).forEach((v, k) => {
        if (k !== 'sort_by') params.append(k, v);
      });
    }
    let sortValue = sortForm ? new FormData(sortForm).get('sort_by') : null;
    if (!sortValue && filterForm) sortValue = new FormData(filterForm).get('sort_by');
    if (sortValue) params.set('sort_by', sortValue);

    this.onSubmitForm(FacetFiltersForm.dedupeParams(params).toString(), e);
  }

  onActiveFilterClick(e) {
    e.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    e = -1 == e.currentTarget.href.indexOf('?') ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(e);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((e) => e.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    var e = this.querySelectorAll('.field__input'),
      t = e[0],
      e = e[1];

    if (e.value) t.setAttribute('max', e.value);
    if (t.value) e.setAttribute('min', t.value);
    if ('' === t.value) e.setAttribute('min', 0);
    if ('' === e.value) t.setAttribute('max', e.getAttribute('max'));
  }

  adjustToValidValues(e) {
    var t = Number(e.value),
      r = Number(e.getAttribute('min')),
      a = Number(e.getAttribute('max'));

    if (t < r) e.value = r;
    if (a < t) e.value = a;
  }

  fillSlider() {
    document.querySelectorAll('.facets__price .facets__range').forEach((e) => {
      var t = e.querySelectorAll('.field__range'),
        r = t[0],
        t = t[1],
        a = Number(t.max) - Number(t.min),
        r = Number(r.value) - Number(t.min),
        t = Number(t.value) - Number(t.min);

      e.setAttribute('style', `--range-min: ${(r / a) * 100}%; --range-max: ${(t / a) * 100}%`);
    });
  }

  controlSlider() {
    var e = document.querySelectorAll('.facets__price .facets__range');
    let s = document.querySelectorAll('.facets__price .facets__price-wrapper');

    e.forEach((e, t) => {
      e = e.querySelectorAll('.field__range');
      let r = e[0],
        a = e[1],
        c = s[t].querySelectorAll('.field__input')[0],
        l = s[t].querySelectorAll('.field__input')[1];

      r.oninput = () => {
        var e = Number(r.value),
          t = Number(a.value);
        if (t < e) {
          r.value = t;
          c.value = t;
        } else {
          c.value = e;
        }
        this.fillSlider();
      };

      if (Number(a.value) <= 0) {
        a.style.zIndex = 2;
      } else {
        a.style.zIndex = 0;
      }

      a.oninput = () => {
        var e = Number(r.value),
          t = Number(a.value);
        if (e <= t) {
          a.value = t;
          l.value = t;
        } else {
          l.value = e;
          a.value = e;
        }
        if (Number(a.value) <= 0) {
          a.style.zIndex = 2;
        } else {
          a.style.zIndex = 0;
        }
        this.fillSlider();
      };
    });
  }

  controlInput() {
    let s = document.querySelectorAll('.facets__price .facets__range');

    document.querySelectorAll('.facets__price .facets__price-wrapper').forEach((e, t) => {
      e = e.querySelectorAll('.field__input');
      let r = e[0],
        a = e[1],
        c = s[t].querySelectorAll('.field__range')[0],
        l = s[t].querySelectorAll('.field__range')[1];

      r.oninput = () => {
        var e = Number(r.value),
          t = Number(a.value);
        c.value = t && t < e ? t : e;
        this.fillSlider();
      };

      a.oninput = () => {
        var e = Number(r.value),
          t = Number(a.value);
        l.value = e <= t ? t : e;
        this.fillSlider();
      };

      r.onblur = () => {
        var e = Number(r.value),
          t = Number(r.getAttribute('min'));
        Number(r.getAttribute('max'));
        if (e < t) {
          c.value = t;
          r.value = t;
        } else {
          c.value = e;
        }
        this.fillSlider();
      };

      a.onblur = () => {
        var e = Number(a.value),
          t = (Number(a.getAttribute('min')), Number(a.getAttribute('max')));
        if (t < e) {
          l.value = t;
          a.value = t;
        } else {
          l.value = e;
        }
        this.fillSlider();
      };
    });
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('a');
    e.setAttribute('role', 'button');
    e.addEventListener('click', this.closeFilter.bind(this));
    e.addEventListener('keyup', (e) => {
      e.preventDefault();
      if ('SPACE' === e.code.toUpperCase()) this.closeFilter(e);
    });
  }

  closeFilter(e) {
    e.preventDefault();
    (this.closest('facet-filters-form') || document.querySelector('facet-filters-form')).onActiveFilterClick(e);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ------------------------------------------------------------------
   FIX: Scroll to top of product grid after facet render
   (prevents the page from jumping to the bottom when a filter is applied)
------------------------------------------------------------------- */
(function () {
  const originalRender = FacetFiltersForm.renderProductGridContainer;

  FacetFiltersForm.renderProductGridContainer = function (html) {
    originalRender.call(FacetFiltersForm, html);

    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    const stickyHeader = document.querySelector(
      '.shopify-section-header-sticky, sticky-header, .section-header'
    );
    const offset = stickyHeader ? stickyHeader.getBoundingClientRect().height + 16 : 16;
    const targetTop = grid.getBoundingClientRect().top + window.scrollY - offset;

    // Only scroll if the user is actually below the top of the grid
    if (window.scrollY > targetTop + 50) {
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    }
  };
})();